import { defineStore } from 'pinia'
import { LOCALES, defaultLocale } from '@/locales'

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    currentLocale: localStorage.getItem('locale') || defaultLocale,
  }),

  actions: {
    setLocale(locale: string) {
      if (Object.values(LOCALES).includes(locale)) {
        this.currentLocale = locale
        localStorage.setItem('locale', locale)
      }
    }
  }
})